export const rateSteps = {
  advisorPresence: 0,
  experience: 1,
  wouldRecommend: 2,
  expertise: 3,
  feedback: 4,
};
